var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92224 4.02182C3.92224 2.9052 4.82638 2 5.94169 2H18.0585C19.1738 2 20.0779 2.9052 20.0779 4.02182V5.28545H3.92224V4.02182Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80103 6.80182L2.0213 17.9381C1.94579 18.4106 2.07298 18.893 2.37154 19.2667C3.31082 20.4422 4.86321 20.9381 6.30894 20.5245L6.54495 20.457C7.12306 20.2917 7.74454 20.3888 8.24481 20.7227L8.62633 20.9773C10.6693 22.3409 13.3307 22.3409 15.3737 20.9773L15.7552 20.7227C16.2555 20.3888 16.8769 20.2917 17.455 20.457L17.6911 20.5245C19.1368 20.9381 20.6892 20.4422 21.6285 19.2667C21.927 18.893 22.0542 18.4106 21.9787 17.9381L20.199 6.80182H3.80103Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkirt);
export default __webpack_public_path__ + "static/media/skirt.da1f9b8e7fed3c60ee682d8afea0622d.svg";
export { ForwardRef as ReactComponent };